import {pxToRem} from '../../../utills/pxToRem'

export default {
    baseStyle: {
        thumb: {
            width: pxToRem(13),
            height: pxToRem(13),
            bg: 'white',
            _checked: {
                bg: 'cav_calltoaction_darkred'
            }
        },
        track: {
            padding: pxToRem(3),
            bg: 'cav_switch_gray',
            transitionProperty: 'none',
            _checked: {
                bg: 'cav_switch_ligh_pink'
            },
            _focusVisible: {
                boxShadow: 'none'
            }
        }
    },
    sizes: {
        md: {
            container: {
                ['--switch-track-width']: pxToRem(35),
                ['--switch-track-height']: pxToRem(13)
            }
        }
    }
}
